<template>
  <div class="space-y-3">
    <input
      v-model="model.name"
      type="text"
      placeholder="Nombre del grupo"
      class="w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
    >

    <textarea
      v-model="model.description"
      rows="2"
      placeholder="Descripción (opcional)"
      class="w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
    />

    <div class="grid grid-cols-2 gap-3">
      <label class="text-xs text-gray-600 dark:text-gray-300">
        Min selección
        <input
          v-model.number="model.min_select_default"
          type="number"
          min="0"
          class="mt-1 w-full rounded-md border border-gray-300 px-2 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        >
      </label>

      <label class="text-xs text-gray-600 dark:text-gray-300">
        Max selección
        <input
          v-model.number="model.max_select_default"
          type="number"
          min="1"
          class="mt-1 w-full rounded-md border border-gray-300 px-2 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        >
      </label>
    </div>

    <label class="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
      <input
        v-model="model.required_default"
        type="checkbox"
        class="h-4 w-4 rounded border-gray-300 text-indigo-600"
      >
      Requerido por defecto
    </label>
  </div>
</template>

<script setup lang="ts">
interface ModifierGroupBasicsForm {
  name: string;
  description: string;
  required_default: boolean;
  min_select_default: number;
  max_select_default: number;
}

const model = defineModel<ModifierGroupBasicsForm>({ required: true });
</script>
